import React, { FC } from 'react';

import { EvIconButton, ExternalLink, Link } from '@evinced-private/ui-common';

import {
	COPY_ISSUE_LINK_DAID,
	OPEN_IN_NEW_TAB_DAID
} from 'data-automation-ids/data-automation-ids';
import { CopyToClipboard } from 'src/common/components/copy-to-clipboard/CopyToClipboard';

const OPEN_IN_NEW_TAB_LABEL = 'Open in a New Tab';

interface IActionButtonsProps {
	textToCopy: string;
	openNewTab: () => void;
}

export const ActionButtons: FC<IActionButtonsProps> = ({ textToCopy, openNewTab }) => {
	return (
		<>
			<CopyToClipboard
				renderJustIcon
				textToCopy={textToCopy}
				iconTitle="Copy Issue link"
				icon={Link}
				dataAutomationId={COPY_ISSUE_LINK_DAID}
			/>
			<EvIconButton
				icon={ExternalLink}
				ariaLabel={OPEN_IN_NEW_TAB_LABEL}
				onClick={openNewTab}
				dataAutomationId={OPEN_IN_NEW_TAB_DAID}
			/>
		</>
	);
};
